import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import store from "Store/index";
import BaseComponent from 'Components/Base/ABaseComponent';
import OrderingListUserMixin from 'Mixins/OrderingListUserMixin';
import { mixins } from 'vue-class-component';

@Component({
    template: "#customer-agreement-item-template"
})
export default class CustomerAgreementItemComponent extends mixins(BaseComponent,OrderingListUserMixin)  {
    @Prop()
    public productKey: string;
    
    public loaded: boolean = true;
    
    
    async created() {
        //if standard user
        if(!this.isAllowed){
        await store.dispatch.customerAgreement.load();
        }
    }
    
    async mounted(){
    }
    
    
    get exists(){
        if(!this.isAllowed){
            return this.list && this.list.includes(this.productKey);
        } else{
            if(this.orderingListItem)
            return this.orderingListItem.find(x => x.productKey == this.productKey && x.isCustomerAgreement);
        }

        
    }

    get orderingListItem(){
        if(this.orderinglist)
        {
            return this.orderinglist.items;
        }
        return null;
    }

    get orderinglist(){
        return store.state.orderingList.currentOrderingList;
    }
    
    
    get list(){
        return store.state.customerAgreement.list;
    }
    
}

Vue.component('customer-agreement-item', CustomerAgreementItemComponent);
